/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Paste_Events_TitleInputs */

const en_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Events`)
};

const fr_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coller les evenements`)
};

const de_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse einfügen`)
};

const it_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla eventi`)
};

const ru_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить события`)
};

const es_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar eventos`)
};

const zh_cn2_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴事件`)
};

const ja_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを貼り付ける`)
};

const hi_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पेस्ट इवेंट्स`)
};

const pt_pt2_shortcut_keys_paste_events_title = /** @type {(inputs: Shortcut_Keys_Paste_Events_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colar eventos`)
};

/**
* | output |
* | --- |
* | "Paste Events" |
*
* @param {Shortcut_Keys_Paste_Events_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_paste_events_title = /** @type {((inputs?: Shortcut_Keys_Paste_Events_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Paste_Events_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_paste_events_title(inputs)
	if (locale === "de") return de_shortcut_keys_paste_events_title(inputs)
	if (locale === "it") return it_shortcut_keys_paste_events_title(inputs)
	if (locale === "ru") return ru_shortcut_keys_paste_events_title(inputs)
	if (locale === "es") return es_shortcut_keys_paste_events_title(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_paste_events_title(inputs)
	if (locale === "ja") return ja_shortcut_keys_paste_events_title(inputs)
	if (locale === "hi") return hi_shortcut_keys_paste_events_title(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_paste_events_title(inputs)
	return en_shortcut_keys_paste_events_title(inputs)
});